import React from 'react';
import { Badge, Container, Toast, ToastBody, ToastHeader,Row,Col } from 'reactstrap';
import './feature.css'


const Feature = (props) => {
  console.log(props)
  return (
    <div style={{backgroundImage:  "url(https://bit.ly/2O5qjYu)"  } }>
    
    <Container className="text-dark" style={{background: '#f8f9fa'  }}>
      
      <h1 className="text-lg-center  pt-4  mt-0">Explore our features</h1>
      
      <Row>
        
        <Col className="text-center bg-light text-dark m-3 p-3 col-md shadow-sm feature_card"  >

          <div className="font-weight-bold">Your Music Player<img src="https://images-na.ssl-images-amazon.com/images/I/71Mpsg+LzLL.png" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
              Hope can play songs for you. Just say <b>"Play Music Song_Name"</b> or <b>"Play Song Song_Name"</b> and it will open your song on youtube.
              
        </Col>
        
        <Col className="text-center bg-light text-dark m-3 p-3 col-md shadow-sm feature_card ">

          <div className="font-weight-bold">Your calculator<img src="https://bit.ly/3r2TcDa" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
              Hope can answer you any mathematical expression in BODMAS form. So just say 
              <b> "Calculate your_expression" </b> 
               for example: Calculate 5+3-2%7

              
      </Col>
        
        <Col className="text-center bg-light text-dark m-3 p-3 col-md shadow-sm feature_card">

          <div className="font-weight-bold">Encyclopedia<img src="https://bit.ly/3b2BhH7" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
              Hope can answer you some simple questions like who is who and what is what and 
              some General questions.
              Hope can also make some mistakes but please don't mind that, it is still learning.

              
      </Col>



      </Row>
      <Row>
       
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">News<img src="https://w7.pngwing.com/pngs/748/607/png-transparent-news-media-newspaper-advertising-information-news-icon-text-orange-logo.png" style={{ width: "100px", height: "50px", padding: "3px" }}></img></div>
              Hope can give you some news. Just say <b>"Give me some news"</b> and it will
              give you the news.
              <br/>
            <br/>
             
          </div>

       
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">Open any Website<img src="https://bit.ly/3sDvA8j" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
            Hope can open any website for you. Just say <b>"Open Website Name"</b>

             
          </div>


        
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">General Talking<img src="https://bit.ly/3dTlo7R" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
            If you are bored, You can talk to Hope and it can chat with you in a friendly way.
          </div>
      </Row>


      <Row>
        
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">Dictionary<img src="https://bit.ly/3sz7UC3" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
              Hope can tell you antonyms, synonyms and meanings of a word. Just say 
              <b>"Antonym of your_word"</b> or <b>"Opposite of your_word"</b> or
              <b>"meaning of your_word"</b>
          </div>

        
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">Weather Report<img src="https://bit.ly/3sz7OdF" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
            Hope can give you information about Weather of a particular city. Just Say 
            <b>"weather of city_name"</b>

             
          </div>


        
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">A lot more<img src="https://bit.ly/2O6g85Z" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
            Hope can give you current time, covid data of india, top 10 news and a lot more.
            Feel free to explore Hope and give feedback to us.
          </div>
      </Row>
    </Container>
  </div>
  
  );
}

export default Feature;



{/* <div style={{backgroundImage:  "url(https://bit.ly/2O5qjYu)"  } }>
    
    <Container className="text-dark" style={{background: '#f8f9fa'  }}>
      
      <h1 className="text-lg-center  pt-4  mt-0">Explore our features</h1>
      
      <Row>
        
        <Col className="text-center bg-light text-dark m-3 p-3 col-md shadow-sm feature_card"  >

          <div className="font-weight-bold">Your Music Player<img src="https://bit.ly/3b1eBah" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
              Hope can play songs for you. Just say <b>"Play Music Song_Name"</b> or <b>"Play Song Song_Name"</b> and it will open your song on youtube.
              
        </Col>
        
        <Col className="text-center bg-light text-dark m-3 p-3 col-md shadow-sm feature_card ">

          <div className="font-weight-bold">Your calculator<img src="https://bit.ly/3r2TcDa" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
              Hope can answer you any mathematical expression in BODMAS form. So just say 
              <b>"Calculate your_expression" </b> 
               for example: Calculate 5+3-2%7

              
      </Col>
        
        <Col className="text-center bg-light text-dark m-3 p-3 col-md shadow-sm feature_card">

          <div className="font-weight-bold">Encyclopedia<img src="https://bit.ly/3b2BhH7" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
              Hope can answer you some simple questions like who is who and what is what and 
              some General questions
              Hope can also make some mistakes but please don't mind that , it is still learning.

              
      </Col>



      </Row>
      <Row>
       
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">News<img src="https://w7.pngwing.com/pngs/748/607/png-transparent-news-media-newspaper-advertising-information-news-icon-text-orange-logo.png" style={{ width: "100px", height: "50px", padding: "3px" }}></img></div>
              Hope can give you some news. Just say <b>"Give me some news"</b> and it will
              give you the news.
              <br/>
            <br/>
             
          </div>

       
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">Open any Website<img src="https://bit.ly/3sDvA8j" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
            Hope can open any website for you. Just say <b>"Open Website Name"</b>

             
          </div>


        
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">General Talking<img src="https://bit.ly/3dTlo7R" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
            If you are bored , You can talk with Hope and it can talk you in friendly way.
          </div>
      </Row>


      <Row>
        
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">Dictionary<img src="https://bit.ly/3sz7UC3" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
              Hope can tell you antonyms , synonyms and meanings of a word , Just say 
              <b>"Antonym of your_word"</b> or <b>"Opposite of your_word"</b> or
              <b>"meaning of your_word"</b>
          </div>

        
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">Weather Report<img src="https://bit.ly/3sz7OdF" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
            Hope can give you information about Weather of a particular city . Just Say 
            <b>"weather of city_name"</b>

             
          </div>


        
        <div className="text-center bg-light text-dark m-3 p-3  col-md shadow-sm feature_card">

          <div className="font-weight-bold">A lot more<img src="https://bit.ly/2O6g85Z" style={{ width: "50px", height: "50px", padding: "3px" }}></img></div>
            Hope can give you current time , covid data of india , top 10 news and a lot more.
            Feel free to explore Hope and give feedback to us.
          </div>
      </Row>
    </Container>
  </div> */}